import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';

export const valuePropType = PropTypes
  .oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

const NULL_VALUE = '@NULL@';
function Selector({
  value, values, onChange, readOnly, maybeNull, id, margin,
}) {
  const displayValues = useMemo(
    () => [{ value: NULL_VALUE, display_name: 'не обрано', disabled: !maybeNull }, ...values],
    [maybeNull, values],
  );

  const onChangeCB = useCallback(
    (e) => {
      const v = e.target.value;
      if (v === NULL_VALUE) onChange(e, null);
      else onChange(e, e.target.value);
    },
    [onChange],
  );
  const dv = useMemo(
    () => (value === null ? NULL_VALUE : value),
    [value],
  );
  return (
    <Select
      displayEmpty
      onChange={onChangeCB}
      value={dv}
      readOnly={readOnly}
      id={id}
      fullWidth
      variant="standard"
      margin={margin}
    >
      {displayValues.map((vv) => (
        <MenuItem key={vv.value} value={vv.value} disabled={vv.disabled}>
          {vv.display_name}
        </MenuItem>
      ))}
    </Select>
  );
}

Selector.propTypes = {
  id: PropTypes.string,
  value: valuePropType,
  values: PropTypes.arrayOf(PropTypes.shape({
    value: valuePropType,
    disabled: PropTypes.bool,
    display_name: PropTypes.string,
    level: PropTypes.number,
    icon: PropTypes.symbol,
  })),
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  maybeNull: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

Selector.defaultProps = {
  id: null,
  value: null,
  values: [],
  readOnly: false,
  maybeNull: false,
  margin: 'dense',
};

export default Selector;
